<style lang="sass" scoped>
.wrong
  color: red !important

.input
  padding-left: 0 !important
  padding-right: 0 !important
  resize: none
  font-size: 16px
  overflow: hidden
  line-height: 20px

.auto_height
  height: 100%

.cancel_over_flow_hidden
  overflow: auto

.font_style
  line-height: 20PX
  font-size: 17PX
</style>

<style lang="sass" scoped>
::v-deep
  .push-from-bottom
    top: -15px !important
    font-size: 12px

  .label
    top: 10px

</style>

<template>
  <div class="container">
    <textarea
      id="textArea"
      :name="name"
      :maxlength="maxlength"
      :value="value"
      :class="{
        'input': true,
        'auto_height': autoHeight,
        'cancel_over_flow_hidden': cancelOverFlowHidden,
        'font_style': cancelOverFlowHidden
      }"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :placeholder="placeholder"
      :required="required"
      :style="{ 'background-color': backgroundColor , height: height + 'px', padding: padding}"
      :type="type"
      @focus="push_from_bottom = true"
      @blur="onBlur"
      @input="handleInput"
    />
    <div class="bar" :style="{ color: color }"></div>
    <label
      class="label"
      :class="{ 'push-from-bottom': push_from_bottom || value, 'wrong': !rePass }"
      :style="{ color: push_from_bottom ? color : 'rgba(51, 68, 85, 0.45)' }"
    >{{ label }}</label>
  </div>
</template>

<script>
import Emitter from 'utils/emitters'

export default {
  mixins: [Emitter],
  inject: {
    itemPass: {
      default: {
        pass: true
      }
    }
  },
  name: 'VueMaterialInputBox',
  props: {
    name: {
      type: String
    },
    maxlength: {
      type: String,
      default: '200'
    },
    value: {
      type: [String, Number]
    },
    autocomplete: {
      default: 'off',
      type: String,
    },
    backgroundColor: {
      default: '#fff',
      type: String,
    },
    color: {
      default: 'rgba(51, 68, 85, 0.45)',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    label: {
      default: null,
      type: String,
    },
    placeholder: {
      default: null,
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    type: {
      default: 'text',
      type: String,
    },
    height: {
      type: [String, Number]
    },
    autoHeight: {
      type: Boolean
    },
    cancelOverFlowHidden: {
      type: Boolean
    },
    padding: {
      type: String
    }
  },

  data() {
    return {
      push_from_bottom: false,
    }
  },

  computed: {
    rePass() {
      return this.itemPass.pass
    }
  },

  created() {
    if (this.placeholder) this.push_from_bottom = true
  },

  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value)
      this.dispatch('PyFormItem', 'on-form-change', event.target.value)
    },

    onBlur(event) {
      this.$emit('pyBlur', event.target.value)
      if (!this.value && !this.placeholder) this.push_from_bottom = false
      this.dispatch('PyFormItem', 'on-form-blur', event.target.value)
    },
  },
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
}

.input {
  padding: 10px 15px 10px 5px;
  display: block;
  /* border: none; */
  color: rgba(0, 0, 0, 0.87);
  width: 100%;
  border-bottom: 1px  solid #D4D4D4;
}

.input:focus {
  outline: none;
}

.bar:before,
.bar:after {
  background-color: #fafafa;
  content: '';
  height: 2px;
  position: absolute;
  transition: all ease 0.3s;
}

.bar:before {
  left: 50%;
}

.bar:after {
  right: 50%;
}

.input:focus ~ .bar:before,
.input:focus ~ .bar:after {
  width: 0;
}

.label {
  bottom: 10px;
  font-size: 17px;
  pointer-events: none;
  position: absolute;
  transition: all ease 0.3s;
}

.push-from-bottom {
  bottom: 45px;
  font-size: 14px;
}
</style>